module.exports = __webpack_public_path__ + "img/Banner-DHL.f4837b6a.png";